export { StrapiImage } from "./StrapiImage";
